import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router';
import moment from 'moment';
import ContextMenu from './contextMenus/projectContext';
import { ModalActions } from '../../actions/modal';
import { ProjectActions } from '../../actions/project';
import { Map } from 'immutable';
import SuspendedCard from './SuspendedCard';

import '../../styles/ProjectCard.css';
import '../../styles/ProjectCardSummary.css';

const ProjectCardContext = ({
  projectId,
  projectUrl,
  onDelete,
  onCopy,
  copying,
  userMode,
  superAdmin,
  suspendProject,
}) => (
  <div className="card-context" style={{ position: 'absolute', right: 0 }}>
    <ContextMenu
      link={projectUrl}
      onDelete={onDelete}
      onCopy={onCopy}
      copying={copying}
      projectId={projectId}
      userMode={userMode}
      superAdmin={superAdmin}
      suspendProject={suspendProject}
    />
  </div>
);

ProjectCardContext.propTypes = {
  projectUrl: PropTypes.string,
  projectId: PropTypes.string,
  onDelete: PropTypes.func,
  onCopy: PropTypes.func,
  userMode: PropTypes.string,
  copying: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default class ProjectCard extends Component {
  static propTypes = {
    project: PropTypes.instanceOf(Map).isRequired,
    user: PropTypes.instanceOf(Map),
    dispatch: PropTypes.func,
    copying: PropTypes.bool,
    userMode: PropTypes.string,
    unassignedButAccAdmin: PropTypes.bool,
  };

  confirmDelete = () => {
    const { dispatch, project } = this.props;
    const name = project.get('name');

    dispatch(
      ModalActions.toggleModal({
        name: 'DeleteConfirmationModal',
        options: {
          deleteType: 'project',
          handleDelete: this.handleDelete,
          name,
        },
      }),
    );
  };

  handleDelete = () => {
    const { project, currentUser, dispatch, deleteRedirect } = this.props;
    const projectId = project.get('id');
    const accountId = project.get('account_id');
    const currentUserId = currentUser.get('id');
    dispatch(
      ProjectActions.deleteProject(
        projectId,
        accountId,
        currentUserId,
        deleteRedirect,
      ),
    );
  };

  copyProject = () => {
    const { dispatch, project, currentUser } = this.props;
    const projectId = project.get('id');
    const accountId = project.get('account_id');
    const currentUserId = currentUser.get('id');
    dispatch(ProjectActions.copyProject(projectId, currentUserId, accountId));
  };

  render() {
    const {
      dispatch,
      project,
      user,
      userMode,
      currentUser,
      unassignedButAccAdmin,
      isSuspended,
      isAccountAdmin,
      suspendProject,
      unsuspendProject,
      accountName,
      planName,
    } = this.props;
    const superAdmin = currentUser.get('role_id') === 1;

    if (isSuspended) {
      return (
        <SuspendedCard
          dispatch={dispatch}
          userMode={userMode}
          project={project}
          superAdmin={superAdmin}
          unsuspendProject={unsuspendProject}
          isAccountAdmin={isAccountAdmin}
        />
      );
    }
    // const description = project.get('description');
    const projectUrl = `/project/${project.get('id')}`;
    // let userCount = project.get('user_count');
    let elementCount = project.get('element_count');
    // let elementTypeCount = project.get('element_type_count');
    let creator = user
      ? user.get('first_name') + ' ' + user.get('last_name')
      : '';
    let createdAt = project.get('created_at')
      ? moment(project.get('created_at')).format('MMM DD, YYYY')
      : 'N/A';
    // console.log('MEEP MEEP', project, project.getIn(['role']));
    const cardStyle = unassignedButAccAdmin ? { opacity: '.4' } : {};
    return (
      <div className="card project-card" style={cardStyle}>
        <ProjectCardContext
          projectUrl={projectUrl}
          onDelete={this.confirmDelete}
          onCopy={this.copyProject}
          projectId={project.get('id')}
          copying={this.props.copying}
          userMode={userMode}
          superAdmin={superAdmin}
          suspendProject={suspendProject}
        />
        <div className="card-body project-header">
          <h3 className="project-name" style={{ font: '500 1.3em Arial' }}>
            <Link to={projectUrl}>{project.get('name')}</Link>
          </h3>
        </div>
        <div className="project-details">
          <ul className="list-group">
            {/* <li className="list-group-item project-description" style={{ font: '.8em Arial' }}>
              <p>{description}</p>
            </li> */}
            {/* <li className="d-flex align-items-center list-group-item justify-content-between">
              Users
              <span className="badge badge-pill badge-secondary">
                {userCount}
              </span>
            </li> */}
            <li className="d-flex align-items-center list-group-item justify-content-between" style={{ font: '.8em Arial' }}>
              Tasks
              <span className="badge badge-pill badge-secondary">
                {elementCount}
              </span>
            </li>
            {/* <li className="d-flex align-items-center list-group-item justify-content-between">
              Element Types
              <span className="badge badge-pill badge-secondary">
                {elementTypeCount}
              </span>
            </li> */}
            <li className="d-flex align-items-center list-group-item justify-content-between" style={{ font: '.8em Arial' }}>
              Creator
              <span className="badge badge-pill badge-secondary">
                {creator}
              </span>
            </li>
            <li className="d-flex align-items-center list-group-item justify-content-between" style={{ font: '.8em Arial' }}>
              Creation Date
              <span className="badge badge-pill badge-secondary">
                {createdAt}
              </span>
            </li>
            <li className="d-flex align-items-center list-group-item justify-content-between" style={{ font: '.8em Arial' }}>
              Account
              <span className="badge badge-pill badge-secondary">
                {accountName || 'N/A'}
              </span>
            </li>
            <li className="d-flex align-items-center list-group-item justify-content-between" style={{ font: '.8em Arial' }}>
              Type
              <span className="badge badge-pill badge-secondary">
                {planName || 'N/A'}
              </span>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/cards/ProjectCard.js